import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="teaching-contents"
export default class extends Controller {
  static targets = ['actionBtn', 'chapterRadio', 'sectionRadio']

  changeActionBtnDisabled() {
    let disabled_action = true
    let all_radio_targets = this.chapterRadioTargets.concat(this.sectionRadioTargets)
    let buttons = this.actionBtnTargets

    for (let i = 0; i < all_radio_targets.length; i++) {
      if (all_radio_targets[i].checked == true) {
        disabled_action = false
        break
      }
    }

    for (let k = 0; k < buttons.length; k++) {
      buttons[k].disabled = disabled_action
    }
  }
}
